import React from 'react';
import { useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import { useNavigate} from "react-router-dom";

import { Pane, Paragraph, Button, toaster } from 'evergreen-ui';

import DELETE_PUBLISHER_USER_MUTATION from '../../graphql/mutations/DeletePublisherUser.js';

function DeleteUser(props) {
  const navigate = useNavigate();

  const profile = useSelector((state) => state.profile.value);

  const [deletePublisherUser, { deletepublisheruser }] = useMutation(DELETE_PUBLISHER_USER_MUTATION);

  const handleDelete = async(e) => {
    e.preventDefault();

    if (profile.publisheruserSet[0].role.name === "owner") {
      window.alert("You are the account owner. If you wish to delete yourself, you must delete your publisher instance. Please see Publisher Settings.");
    } else {
      if (window.confirm("Are you sure you wish to delete your account? All data will be deleted.")) {
        await deletePublisherUser(
        {
          variables: {
            id: parseInt(profile.publisheruserSet[0].id),
          }
        });

        toaster.closeAll();
        toaster.success(`Your user account have been successfully deleted.`);

        fetch('/api/v1/auth/logout/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${localStorage.getItem('token')}`
          }
        })
          .then(res => res.json())
          .then(data => {
            localStorage.clear();

            navigate('/thanks-for-trying-workinglit');
          });
      }
    }
  };

  return (
    <Pane display="flex" paddingY={8} alignItems="center">
      <Button intent="danger" marginRight={16} onClick={handleDelete}>
        Delete Account
      </Button>
      <Paragraph>
        Warning - deleting an account is not reversible.
      </Paragraph>
    </Pane>
  );
}

export default DeleteUser;
